const downloadElementAsPdf = async (
  element: HTMLElement,
  fileName: string,
  onSuccess?: () => any,
) => {
  // const { default: html2pdf } = await import("html2pdf.js");
  // return html2pdf(element);

  // lazy load since this is quite big
  const { jsPDF } = await import("jspdf");

  try {
    // load fonts, and should continue if failed
    // TODO: seems to have some issue w/ custom fonts font weight
    await Promise.allSettled([
      import("./fonts/NotoSans-Regular-normal.js"),
      import("./fonts/NotoSans-Medium-normal.js"),
      import("./fonts/NotoSans-Bold-normal.js"),
      import("./fonts/Questrial-Regular-normal.js"),
      import("./fonts/Qwigley-normal.js"),
    ]);
  } catch (e) {
    console.warn(e);
  }

  const jsPdfDocument = new jsPDF({
    orientation: "p",
    unit: "pt",
    format: "letter",
    putOnlyUsedFonts: true,
  });

  jsPdfDocument.viewerPreferences({ FitWindow: true });

  return new Promise<void>((resolve) => {
    // TODO: since we are generating pdf automatically, we need to add the page layout, e.g. margin
    jsPdfDocument.html(element, {
      callback: (document) => {
        document.save(fileName);

        if (onSuccess) {
          onSuccess();
        }

        resolve();
      },
      // inch to pt
      width: 8.5 * 72,
      windowWidth: window.innerWidth * 0.75,
      // margin: [4, 4, 4, 4],
      // autoPaging: "text",
    });
  });
};

export default downloadElementAsPdf;
